import {FC} from 'react';
import {RegistrationWizard} from 'widgets/registration';

export const RegistrationPage: FC = () => {
	return <RegistrationWizard />;
};
